var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 0;
var op = 150.000006109625;
var w = 467;
var h = 467;
var nm = "Rocket  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Rocket",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                s: true,
                x: {
                    a: 0,
                    k: 214.035,
                    ix: 3
                },
                y: {
                    a: 0,
                    k: 252.911,
                    ix: 4
                }
            },
            a: {
                a: 0,
                k: [
                    500,
                    500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                746.5,
                                482.5
                            ],
                            [
                                516.5,
                                712.5
                            ],
                            [
                                286.5,
                                482.5
                            ],
                            [
                                516.5,
                                252.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        8.818,
                                        23.513
                                    ],
                                    [
                                        -26.453,
                                        0
                                    ],
                                    [
                                        -2.939,
                                        -23.513
                                    ],
                                    [
                                        26.453,
                                        -17.635
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 1,
                        ty: "sh",
                        ix: 2,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -35.27,
                                        -3.919
                                    ],
                                    [
                                        27.432,
                                        -27.432
                                    ],
                                    [
                                        23.513,
                                        -7.838
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -27.432,
                                        27.432
                                    ]
                                ],
                                o: [
                                    [
                                        3.919,
                                        35.27
                                    ],
                                    [
                                        -27.432,
                                        27.432
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        7.838,
                                        -23.513
                                    ],
                                    [
                                        27.432,
                                        -27.432
                                    ]
                                ],
                                v: [
                                    [
                                        155.776,
                                        -88.175
                                    ],
                                    [
                                        120.506,
                                        5.878
                                    ],
                                    [
                                        44.088,
                                        58.784
                                    ],
                                    [
                                        8.818,
                                        23.513
                                    ],
                                    [
                                        61.723,
                                        -52.905
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 2",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 2,
                        ty: "sh",
                        ix: 3,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        114.628,
                                        -82.297
                                    ],
                                    [
                                        149.898,
                                        -47.027
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 3",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 3,
                        ty: "sh",
                        ix: 4,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -5.542,
                                        -5.542
                                    ],
                                    [
                                        5.542,
                                        -5.542
                                    ],
                                    [
                                        5.542,
                                        5.542
                                    ],
                                    [
                                        -5.542,
                                        5.542
                                    ]
                                ],
                                o: [
                                    [
                                        5.542,
                                        5.542
                                    ],
                                    [
                                        -5.542,
                                        5.542
                                    ],
                                    [
                                        -5.542,
                                        -5.542
                                    ],
                                    [
                                        5.542,
                                        -5.542
                                    ]
                                ],
                                v: [
                                    [
                                        104.593,
                                        -36.992
                                    ],
                                    [
                                        104.593,
                                        -16.922
                                    ],
                                    [
                                        84.523,
                                        -16.922
                                    ],
                                    [
                                        84.523,
                                        -36.992
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 4",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 4,
                        ty: "sh",
                        ix: 5,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        44.088,
                                        58.784
                                    ],
                                    [
                                        67.601,
                                        94.054
                                    ],
                                    [
                                        91.115,
                                        70.54
                                    ],
                                    [
                                        85.236,
                                        41.149
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 5",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 19,
                                    s: [
                                        174.971,
                                        757.428
                                    ],
                                    to: [
                                        43.333,
                                        -43.333
                                    ],
                                    ti: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167
                                    },
                                    t: 29,
                                    s: [
                                        434.971,
                                        497.428
                                    ],
                                    to: [
                                        0,
                                        0
                                    ],
                                    ti: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    t: 102.000004154545,
                                    s: [
                                        454.971,
                                        477.428
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 6,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 10.0000004073083,
        op: 910.00003706506,
        st: 4.00000016292334,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Thrust right",
        parent: 3,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    458.484,
                    576.786,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                288.5,
                                -93.5
                            ],
                            [
                                58.5,
                                136.5
                            ],
                            [
                                -171.5,
                                -93.5
                            ],
                            [
                                58.5,
                                -323.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 11,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    2.939,
                                                    -2.939
                                                ],
                                                [
                                                    -122.882,
                                                    120.496
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    2.939,
                                                    -2.939
                                                ],
                                                [
                                                    -15.439,
                                                    15.439
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tm",
                        s: {
                            a: 0,
                            k: 0,
                            ix: 1
                        },
                        e: {
                            a: 0,
                            k: 50,
                            ix: 2,
                            x: "var $bm_rt;\nvar timeToStop;\n$bm_rt = timeToStop = 4;\nif (time > timeToStop) {\n    $bm_rt = value;\n} else {\n    $bm_rt = wiggle(2, 55);\n}"
                        },
                        o: {
                            a: 0,
                            k: 0,
                            ix: 3
                        },
                        m: 1,
                        ix: 3,
                        nm: "Trim Paths 1",
                        mn: "ADBE Vector Filter - Trim",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                -14.068,
                                12.617
                            ],
                            ix: 2,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Thrust center').content('Group 1').transform.position;"
                        },
                        a: {
                            a: 0,
                            k: [
                                -14.068,
                                12.617
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 10.0000004073083,
        op: 910.00003706506,
        st: 10.0000004073083,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Thrust left",
        parent: 3,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    406.714,
                    558.516,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    -16.5,
                    17,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.025,
                                0
                            ]
                        ],
                        v: [
                            [
                                328.5,
                                -57.5
                            ],
                            [
                                98.5,
                                172.5
                            ],
                            [
                                -131.5,
                                -57.5
                            ],
                            [
                                98.5,
                                -287.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 11,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    2.939,
                                                    -2.939
                                                ],
                                                [
                                                    -116.652,
                                                    116.226
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    2.939,
                                                    -2.939
                                                ],
                                                [
                                                    -15.439,
                                                    15.439
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tm",
                        s: {
                            a: 0,
                            k: 0,
                            ix: 1
                        },
                        e: {
                            a: 0,
                            k: 50,
                            ix: 2,
                            x: "var $bm_rt;\nvar timeToStop;\n$bm_rt = timeToStop = 4;\nif (time > timeToStop) {\n    $bm_rt = value;\n} else {\n    $bm_rt = wiggle(6, 55);\n}"
                        },
                        o: {
                            a: 0,
                            k: 0,
                            ix: 3
                        },
                        m: 1,
                        ix: 3,
                        nm: "Trim Paths 1",
                        mn: "ADBE Vector Filter - Trim",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                -10.479,
                                11.945
                            ],
                            ix: 2,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Thrust center').content('Group 1').transform.position;"
                        },
                        a: {
                            a: 0,
                            k: [
                                -10.479,
                                11.945
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 10.0000004073083,
        op: 910.00003706506,
        st: 10.0000004073083,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Thrust center",
        parent: 3,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    449.667,
                    550.333,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.025,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                296.5,
                                -69.5
                            ],
                            [
                                66.5,
                                160.5
                            ],
                            [
                                -163.5,
                                -69.5
                            ],
                            [
                                66.5,
                                -299.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 11,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    11.757,
                                                    -11.757
                                                ],
                                                [
                                                    -238.744,
                                                    238.769
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    11.757,
                                                    -11.757
                                                ],
                                                [
                                                    -41.744,
                                                    41.769
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tm",
                        s: {
                            a: 0,
                            k: 0,
                            ix: 1
                        },
                        e: {
                            a: 0,
                            k: 60,
                            ix: 2,
                            x: "var $bm_rt;\nvar timeToStop;\n$bm_rt = timeToStop = 4;\nif (time > timeToStop) {\n    $bm_rt = value;\n} else {\n    $bm_rt = wiggle(8, 55);\n}"
                        },
                        o: {
                            a: 0,
                            k: 0,
                            ix: 3
                        },
                        m: 1,
                        ix: 3,
                        nm: "Trim Paths 1",
                        mn: "ADBE Vector Filter - Trim",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 19,
                                    s: [
                                        -260,
                                        260
                                    ],
                                    to: [
                                        40,
                                        -40
                                    ],
                                    ti: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167
                                    },
                                    t: 29,
                                    s: [
                                        -20,
                                        20
                                    ],
                                    to: [
                                        0,
                                        0
                                    ],
                                    ti: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    t: 102.000004154545,
                                    s: [
                                        0,
                                        0
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 10.0000004073083,
        op: 910.00003706506,
        st: 10.0000004073083,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Fill",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 15.0000006109625,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    233,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.972549021244,
                                0.949019610882,
                                0.972549021244,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Rocket = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Rocket as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Rocket.json.es.js.map
